document.querySelector('.dip-search__input').addEventListener('click', function () {
  if (document.querySelector('.dip-search__dropdown').classList.contains('dip-search__dropdown--active')) {
    document.querySelector('.dip-search__dropdown').classList.remove('dip-search__dropdown--active');
  }
  else {
    document.querySelector('.dip-search__dropdown').classList.add('dip-search__dropdown--active');
  }
});

document.querySelectorAll('.dip-search__dropdown li').forEach(function (liElem) {
  liElem.addEventListener('click', function () {
    document.querySelector('.dip-search__dropdown').classList.remove('dip-search__dropdown--active');
    document.querySelector('.dip-search__input__value strong').innerHTML = this.innerHTML;
    document.querySelector('.dip-search__submit').disabled = false;
  });
});

document.querySelector('.dip-search__submit').addEventListener('click', function () {
  let selectedValue = document.querySelector('.dip-search__input__value strong').innerHTML.trim();
  let collectionURL = '';
  if(selectedValue == "Car Kits") { 
    collectionURL = "/collections/all-car-kits-by-color"; 
  } 
  else if (selectedValue == "Wheel Kits") { 
    collectionURL = "/collections/wheel-kits"; 
  } else if (selectedValue == "Emblem Kits") { 
    collectionURL = "/collections/emblem-kits"; 
  } else if (selectedValue == "Luna One Aerosols") { 
    collectionURL = "/collections/luna-one"; 
  }
  window.location = collectionURL;
});